import React, {Component} from 'react';
import {withRouter, Redirect, Link} from 'react-router-dom';
import {Alert, Button, Card, TextField} from '@betareader/design-system';
import queryString from 'query-string';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReactGA from 'react-ga';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const {redirect} = queryString.parse(props.location.search);
    this.state = {
      email: '',
      redirect: typeof redirect === 'string' ? redirect : undefined,
      errorMessage: null,
      sent: false,
      sending: false,
    };
  }

  componentDidMount() {
    const {location} = this.props.history;
    ReactGA.pageview(location.pathname + location.hash + location.search);
    firebase.auth().getRedirectResult()
      .then(result => {
        if (result?.user) {
          localStorage.removeItem('sign-in-mode');
          this.setState({user: result.user, redirect: this.state.redirect || '/mymanuscripts'});
        }
      })
      .catch(error => this.setState({errorMessage: error.message}));
  }

  resetPassword = async event => {
    event.preventDefault();
    const {email, sending} = this.state;
    if (!email || sending) return;
    this.setState({sending: true, errorMessage: null});
    try {
      await firebase.auth().sendPasswordResetEmail(email);
      this.setState({sent: true});
    } catch (error) {
      this.setState({errorMessage: error.message});
    } finally {
      this.setState({sending: false});
    }
  };

  render() {
    const {email, redirect, errorMessage, sent, sending, user: redirectUser} = this.state;
    if (this.props.user || redirectUser) {
      return <Redirect to={{pathname: redirect || '/profile'}} />;
    }
    return (
      <main style={{minHeight: '100%', display: 'grid', placeItems: 'center', padding: 'var(--br-space-4)'}}>
        <Card style={{maxWidth: 450, width: '100%', padding: 'var(--br-space-4)'}}>
          <h1>Reset password</h1>
          {sent ? (
            <Alert variant='info'>
              We've sent a password reset email to {email}. Please follow the
              instructions in the email, and then <Link to='/signin'>sign in</Link>.
            </Alert>
          ) : (
            <form onSubmit={this.resetPassword} style={{display: 'grid', gap: 'var(--br-space-3)'}}>
              <TextField id='password-reset-email' type='email' required label='E-mail address'
                placeholder='E-mail address' value={email}
                onChange={event => this.setState({email: event.target.value, errorMessage: null})} />
              <Button type='submit' disabled={sending || !email} aria-busy={sending}>
                {sending ? 'Sending…' : 'Send password reset email'}
              </Button>
              {errorMessage && <Alert variant='error'>{errorMessage}</Alert>}
              <p>Remember your password? <Link to='/signin'>Sign in here</Link>.</p>
            </form>
          )}
        </Card>
      </main>
    );
  }
}

const mapStateToProps = state => ({user: state.user.user});
const mapDispatchToProps = dispatch => bindActionCreators({changePage: newPage => push(newPage)}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));
